
import SkeletonTitle from "../../components/skeleton/Title.vue";
import SkeletonListControl from "./components/skeleton/ListControl.vue";
import SkeletonList from "./components/skeleton/List.vue";
import FrameService from "../../src/FrameService";
import ItemListFilter from "../../components/Filter/index.vue";
import SortComponent from "../../components/Sort/index.vue";
import { PageIdentity } from "../../src/Entity/Page";
import PreviewCard from "../../components/Card/PreviewCard/index.vue";
import { PropType } from "vue";
import { UrlService } from "../../src/Service/Url/UrlService";
import { Filters } from "../../src/Entity/Filter";
import { defineComponent } from "vue";
import { Page } from "../../src/Entity/Page";
import { PageItemInterface } from "modules/spravochnik/dt-front-page-generator/src/Entity";
import Paginate from "../../components/Paginator/Paginator.vue";
import ChunkCollection from "modules/spravochnik/dt-front-page-generator/src/Utils/ChunkCollection";

export default defineComponent({
    props: {
        pageIdentity: {
            type: Object as PropType<PageIdentity>,
            required: true,
        },
    },
    components: {
        SkeletonTitle,
        SkeletonListControl,
        SkeletonList,
        ItemListFilter,
        SortComponent,
        PreviewCard,
        Paginate,
    },
    computed: {
        page(): Page {
            return this.$store.getters["page/page"];
        },
        fetchPageItems(): ChunkCollection<PageItemInterface> {
            return this.$store.getters["page/fetchPageItems"];
        },
        pageNumber(): number {
            return this.$store.getters["page/pageNumber"];
        },
    },
    methods: {
        async changePage(pageNumber: number) {
            this.$store.dispatch("page/changePageNumber", pageNumber);
            this.urlService.changePageNumber(pageNumber);

            await this.loadPageItems();
        },
        async onApplySort(value) {
            this.sorting = value;
            this.urlService.apply();
            await this.loadPageItems();
        },
        async onApplyFilter(filters: Filters) {
            this.$store.dispatch("page/resetPageNumber");
            this.urlService.apply();
            await this.loadPageItems();
        },
        async onSetFilter(identity: string, ...args) {
            this.$store.dispatch("page/resetPageNumber");
            this.page.filters.reset();
            this.page.filters.addFilterByIdentity(identity, ...args);
            this.urlService.apply();
            await this.loadPageItems();
        },
        async onResetFilter() {
            this.$store.dispatch("page/resetPageNumber");
            this.urlService.apply();
            await this.loadPageItems();
        },
        async loadPageItems() {
            this.loadingPageItems = true;
            await this.$store.dispatch("page/loadPageItems", this.page);
            this.loadingPageItems = false;
        },
        goBack() {
            return this.$router.go(-1);
        }
    },
    created() {
        (new FrameService()).off();
        document.querySelector("body").style.overflow = "auto";
    },
    async mounted() {
        this.loading = true;
        await this.$store.dispatch("page/changePageNumber", parseInt(this.$route.query.page || 1, 10));
        await this.$store.dispatch("page/loadPageByIdentity", this.pageIdentity);
        this.urlService = new UrlService(this.$router, this.page, this.pageNumber).updateEntity().apply();

        this.loading = false;
        await this.loadPageItems();

        // SEO
        if (this.page.seo.metaTitle){
            document.title = this.page.seo.metaTitle;
        } else {
            document.title = this.page.name.name;
        }

        if (this.page.seo.metaDescription){
            document.querySelector('meta[name="description"]').setAttribute("content", this.page.seo.metaDescription);
        } else {
            document.querySelector('meta[name="description"]').setAttribute("content", this.page.name.name);
        }

        if (this.page.seo.metaImage){
            document.querySelector('meta[property="og:image"]').setAttribute("content", this.page.seo.metaImage.url);
        }
    },
    data() {
        return {
            loading: true,
            loadingPageItems: true,
            urlService: null as UrlService,
        };
    },
});
